// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SystemDetailsModel } from 'src/app/api/remote-api/.portal.generated/models';
import { APICallGateComponent } from 'src/app/modules/shared/components/api-call-gate.component';
import { DnaSyngoviaDataConnections } from '../../interfaces/dna-syngovia-data-connections';
import { DnaSyngoviaGroupNode } from '../../interfaces/dna-syngovia-group-node';
import { DnaSyngoviaChartMapComponent } from '../dna-syngovia-chart-map/dna-syngovia-chart-map.component';
import { DnaSyngoviaGroupTableListComponent } from '../dna-syngovia-group-table-list/dna-syngovia-group-table-list.component';

@Component({
  standalone: true,
  imports: [
    APICallGateComponent,
    CommonModule,
    TranslateModule,
    DnaSyngoviaChartMapComponent,
    DnaSyngoviaGroupTableListComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-dna-syngovia-customer-overview',
  templateUrl: './dna-syngovia-customer-overview.component.html',
  styleUrls: ['./dna-syngovia-customer-overview.component.scss'],
})
export class DnaSyngoviaCustomerOverviewComponent {
  @Input({ required: true }) systemDetails!: SystemDetailsModel;
  @Input({ required: true }) dataConnections!: DnaSyngoviaDataConnections;

  protected selectedGroupNode: DnaSyngoviaGroupNode | null | undefined;

  public constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  protected onSelectedGroupNodeChange(groupNode: DnaSyngoviaGroupNode): void {
    this.clearTableList();

    this.selectedGroupNode = groupNode;
    this.scrollIntoTable();
  }

  private clearTableList(): void {
    this.selectedGroupNode = null;
    this.changeDetectorRef.detectChanges();
  }

  private scrollIntoTable(): void {
    setTimeout(this.calculateScrollOffset, 100);
  }

  private readonly calculateScrollOffset = () => {
    const offsetInPixels = 16;
    const searchBarHeight = this.getSearchBarHeight();
    const tableRectTop = document
      .getElementById('syngovia-table-list')
      ?.getBoundingClientRect().top;

    window.scrollTo({
      top:
        (tableRectTop ?? 0) +
        document.documentElement.scrollTop -
        searchBarHeight -
        offsetInPixels,
      behavior: 'smooth',
    });
  };

  private getSearchBarHeight(): number {
    let searchBar = document.querySelector('sh-access-bar');
    if (!searchBar) {
      searchBar = document.querySelector('app-search-pane');
    }

    const searchBarHeight = searchBar?.getBoundingClientRect().height;
    return searchBarHeight ?? 0;
  }
}
